<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <Select v-model="search.noticeType" style="width: 16em;margin-left: 10px;" placeholder="请选择通知类别"
          @on-change="changeNotice" clearable>
          <Option v-for="(value, key) in ObjType" :key="key" :value="key">{{ value }}</Option>
        </Select>
        <Select v-model="search.noticeMethod" style="width: 16em;margin-left: 10px;" placeholder="请选择通知方式"
          @on-change="changeNotice" clearable>
          <Option v-for="(value, key) in ObjMethod" :key="key" :value="key">{{ value }}</Option>
        </Select>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="通知类型：" prop="noticeType">
          <Select v-model="formValidate.noticeType" placeholder="请选择通知类型" clearable
            style="width: 10em;text-align:center;">
            <Option v-for="(value, key) in ObjType" :key="key" :value="key">{{ value }}</Option>
          </Select>
        </FormItem>
        <FormItem label="通知方式：" prop="noticeMethod">
          <Select v-model="formValidate.noticeMethod" placeholder="请选择通知方式" clearable
            style="width: 10em;text-align:center;">
            <Option v-for="(value, key) in ObjMethod" :key="key" :value="key">{{ value }}</Option>
          </Select>
        </FormItem>
        <!-- 时间选择 -->
        <FormItem label="到期前：">
          <CheckboxGroup v-model="formValidate.dueDateBefore">
            <Checkbox v-for="(value, key) in ObjTime" :key="key" :label="key">{{ value }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="到期后：">
          <CheckboxGroup v-model="formValidate.dueDateAfter">
            <Checkbox v-for="(value, key) in ObjTime" :key="key" :label="key">{{ value }}</Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}
</style>

<script>
import toolbar from "../toolBar.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "通知类型",
            align: "center",
            render: (h, params) => {
              var that = this;
              return h("div", [
                h("span", {}, that.getTypeName(params.row.noticeType))
              ]);
            }
          },
          {
            title: "通知方式",
            align: "center",
            render: (h, params) => {
              var that = this;
              return h("div", [
                h("span", {}, that.getMethodName(params.row.noticeMethod))
              ]);
            }
          },
          {
            title: "到期前时间规则",
            key: "",
            align: "center",
            render: (h, params) => {
              var that = this;
              return h("div", [
                h("span", {}, that.getTimeNames(params.row.dueDateBefore))
              ]);
            }
          },
          {
            title: "到期后时间规则",
            align: "center",
            render: (h, params) => {
              var that = this;
              return h("div", [
                h("span", {}, that.getTimeNames(params.row.dueDateAfter))
              ]);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 160,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          noticeType: params.row.noticeType,
                          noticeMethod: params.row.noticeMethod,
                          dueDateBefore: params.row.dueDateBefore ? JSON.parse(params.row.dueDateBefore) : [],
                          dueDateAfter: params.row.dueDateAfter ? JSON.parse(params.row.dueDateAfter) : [],
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        noticeType: null,
        noticeMethod: null,
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        noticeType: "",
        noticeMethod: "",
        dueDateBefore: [],
        dueDateAfter: [],
      },
      // 验证
      ruleValidate: {
        noticeType: [
          { required: true, message: "不能为空", trigger: "change" }
        ],
        noticeMethod: [
          { required: true, message: "不能为空", trigger: "change" }
        ],
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      ObjMethod: {},
      ObjTime: {},
      ObjType: {},
    };
  },
  components: {
    toolbar,
  },
  created() {
    this.getNoticeType();
    this.getNoticeTime();
    this.getNoticeMethod();
    this.getData(); // 数据初始化
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        noticeType: "",
        noticeMethod: "",
        dueDateBefore: [],
        dueDateAfter: [],
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getNoticeList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getNoticeDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postNoticeAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Deploy.postNoticeEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 获取通知类型
    getNoticeType() {
      this.$api.Deploy.getNoticeType(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.ObjType = res.data;
        } else {
          this.$Notice.warning({
            title: "获取通知类型枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取发送方法枚举
    getNoticeMethod() {
      this.$api.Deploy.getNoticeMethod(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.ObjMethod = res.data;
        } else {
          this.$Notice.warning({
            title: "获取发送方法枚举失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 获取时间枚举值
    getNoticeTime(msg) {
      this.$api.Deploy.getNoticeTime({ content: { unitName: msg } }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.ObjTime = Object.entries(res.data)
            .sort((a, b) => a[0].localeCompare(b[0]))
            .reduce((acc, [key, value]) => {
              acc[key] = value;
              return acc;
            }, {});
        } else {
          this.$Notice.warning({
            title: "获取时间枚举值失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    getMethodName(name) {
      return this.ObjMethod[name];
    },
    getTypeName(name) {
      return this.ObjType[name];
    },
    getTimeNames(s) {
      let arr = JSON.parse(s).sort();//.join(', ')
      let out = "";
      arr.forEach((item) => {
        out += this.ObjTime[item] + ", ";
      });
      return out;
    },
    changeNotice() {
      this.getData();
    },
  }
};
</script>